import MercadoPagoDebit from '../Views/MercadoPagoDebit'

const MercadoPagoRoute = [{
    path: '/pagos',
    name: 'pagos',
    component: MercadoPagoDebit,
}]

export default MercadoPagoRoute
